// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/illustration-template/src/index.tsx

import baseIllustration from '@bubble-ui/temp-illustration-base';
var IllustrationSalaryPath = 'M65.123 28.648L78 12.804l-2.2-2.3a32.1 32.1 0 00-45.6 0l-2.2 2.3 14.157 17.418c-9.927 4.47-18.153 14.97-23.091 24.782H7v19h5v5H7v19h71.5c8.538-.054 15.445-6.962 15.5-15.5v-1c0-14.408-8.952-34.833-21.759-45.81a22.601 22.601 0 0014.959-9.59l-5.8-3.9a15.7 15.7 0 01-12.9 6.8 14.494 14.494 0 01-3.377-.356zM78.5 91.004H44v-5h5v-19h-5v-12H26.992c6.109-10.628 15.483-20 25.008-20h2c15.9 0 33 27.3 33 46.5v1a8.5 8.5 0 01-8.5 8.5zm-41-77.6l11.956 14.75c.84-.099 1.688-.15 2.544-.15h2c.853 0 1.701.051 2.543.15L68.5 13.404c-9.073-7.217-21.927-7.217-31 0zM14 86.004h23v5H14v-5zm28-12v5H19v-5h23zm-28-7h23v-5H14v5z';
var IllustrationSalary = baseIllustration('IllustrationSalary', {
  getPath: () => IllustrationSalaryPath
}, 'ColoredIllustrationSalary');

/**
 * @deprecated this component is outdated and will be removed with v6.0.0
 */
export default IllustrationSalary;
//# sourceMappingURL=index.js.map